export default {
  sectionHeaders: [
    {
      text: "Завдання",
      value: "title",
      style: "max-width: 66,6%; width: 66,6%; min-width: 66,6%",
      sortable: false,
      type: "text-editor",
    },
    {
      text: "t(avg)",
      tooltip: "t (avg) - оцінки min, norm, max усереднюються за формулою: t (avg) = (min + 4 * norm + max) / 6",
      value: "estimateAvg",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
    },
    {
      text: "min",
      tooltip: "min - мінімальний час виконання завдання. Оцінка при відсутності перешкод та додаткових умов",
      value: "estimateMin",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "estimate-editor",
    },
    {
      text: "norm",
      tooltip: "norm – нормальний час виконання завдання. Стільки згідно зі статистикою зазвичай виконуються аналогічні завдання, після уточнень і доповнень",
      value: "estimateNorm",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "estimate-editor",
    },
    {
      text: "max",
      tooltip: "max – максимальний час виконання завдання. Можливий час в разі непередбачених перешкод і додаткових умов, ймовірність такої ситуації зустрічається рідко, але такі ризики є",
      value: "estimateMax",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "estimate-editor",
    },
    {
      text: "Jira",
      tooltip: "Код задачі Jira",
      value: "issueTrackRef",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "jira-editor",
    },
  ],
  totalHeaders: [
    {
      text: "",
      value: "title",
      style: "max-width: 65,6%; width: 65.6%; min-width: 65.6%; text-align: end",
      sortable: false,
    },
    {
      text: "t(avg)",
      value: "estimateAvg",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "chips",
    },
    {
      text: "min  ",
      value: "estimateMin",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "chips",
    },
    {
      text: "norm ",
      value: "estimateNorm",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "chips",
    },
    {
      text: "max  ",
      value: "estimateMax",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
      type: "chips",
    },
    {
      text: "",
      value: "emptyColumn",
      style: "max-width: 6.6%; width: 6.6%; min-width: 6.6%",
      sortable: false,
    },
  ],
};
